import React, { useEffect, useRef } from 'react';
import H from '@here/maps-api-for-javascript/bin/mapsjs.bundle.harp';
import getCountryISO2 from 'country-iso-3-to-2';
import styled from '@emotion/styled';
import withTranslation from '../../hoc/withTranslation';
import '@here/maps-api-for-javascript/bin/mapsjs-ui.css';
import {
  createBaseLayers,
  createMap,
  createSettingsControl,
  createUI,
  setUnitSystem,
} from '../../utils/map/MapUtils';

const StyledMap = styled.div({
  width: '100%',
  overflow: 'hidden',
  position: 'fixed',
  height: 'calc(100vh - 3rem)',
});

const NewMap = ({ user }) => {
  const mapRef = useRef(null);
  const mapUIRef = useRef(null);
  const settingsControlRef = useRef(null);
  const map = useRef(null);

  const ISO2Code = getCountryISO2(user.politicalView);
  const engineType = H.Map.EngineType.HARP;
  const mapLayers = createBaseLayers(engineType, user.language, ISO2Code);

  // TODO bounds - once we have some data use map.getViewModel().setLookAtData()

  useEffect(() => {
    if (!map.current) {
      map.current = createMap(mapLayers, mapRef, engineType);
      const settingsControl = createSettingsControl(mapLayers);
      mapUIRef.current = createUI(mapLayers, map.current, settingsControl);
      settingsControlRef.current = settingsControl;
      setUnitSystem(mapUIRef.current, user.distance);
    }
  }, [mapLayers, user.distance]);

  useEffect(() => {
    if (mapUIRef.current) setUnitSystem(mapUIRef.current, user.distance);
  }, [user.distance]);

  return <StyledMap ref={mapRef} />;
};

export default withTranslation(NewMap);
